export const API_URL = process.env.REACT_APP_API_URL
export const REACT_APP_API_KEY = process.env.REACT_APP_API_KEY
export const REACT_APP_API_SECRET = process.env.REACT_APP_API_SECRET
export const REACT_APP_ACCESS_TOKEN = process.env.REACT_APP_ACCESS_TOKEN
export const REACT_APP_SHOP_NAME = process.env.REACT_APP_SHOP_NAME

